var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('main', {
    staticClass: "page"
  }, [_c('div', {
    class: `theme-vdoing-wrapper ${_vm.bgStyle}`
  }, [_vm.isArticle() ? _c('ArticleInfo') : _c('div', {
    staticClass: "placeholder"
  }), _vm._v(" "), _vm.pageComponent ? _c(_vm.pageComponent, {
    tag: "component",
    staticClass: "theme-vdoing-content"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm.showRightMenu ? _c('RightMenu') : _vm._e(), _vm._v(" "), _vm.showTitle ? _c('h1', [(_vm.$themeConfig.titleBadge === false ? false : true) ? _c('img', {
    attrs: {
      "src": _vm.currentBadge
    }
  }) : _vm._e(), _vm._v(_vm._s(this.$page.title)), _vm.$frontmatter.titleTag ? _c('span', {
    staticClass: "title-tag"
  }, [_vm._v(_vm._s(_vm.$frontmatter.titleTag))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.isShowSlotT ? _vm._t("top") : _vm._e(), _vm._v(" "), _c('Content', {
    staticClass: "theme-vdoing-content"
  })], 2), _vm._v(" "), _vm.isShowSlotB ? _vm._t("bottom") : _vm._e(), _vm._v(" "), _c('PageEdit'), _vm._v(" "), _c('PageNav', _vm._b({}, 'PageNav', {
    sidebarItems: _vm.sidebarItems
  }, false))], 2), _vm._v(" "), _vm.isShowUpdateBar ? _c('UpdateArticle', {
    attrs: {
      "length": 3,
      "moreArticle": _vm.updateBarConfig && _vm.updateBarConfig.moreArticle
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };